export class SlackReactionAlreadyExistsError extends Error {}
